import { useQuery } from 'react-query';
import { client } from 'utils/api-client';
import { useNotification } from 'components/NotificationBanner';

export default function useFetchDashboardTimeGraph(params: any) {
  const notification = useNotification();

  return useQuery(
    ['dashboard-time-graph', params],
    () => client(`dashboard/time-graph/`, { params }).then((res) => res.data)
    , {
      onError: (error) => {
        notification.error({
          message: "Error occurred",
          description: error.errors
        })
      }
    });
}
